import CIcon from "@coreui/icons-react";
import { CCol, CLink, CWidgetProgress } from "@coreui/react";
import { useHistory } from "react-router-dom";

const CustomWidgetProgress = ({ item, index }) => {
  const history = useHistory();
  const handleFooterClick = (url) => {
    if (url !== null || url !== undefined) history.push(url);
  };
  return (
    <CCol xs="12" sm="6" md="6" lg="6" xl="4" xxl="3" key={index}>
      <CWidgetProgress
        key={index}
        inverse
        color={item.color}
        variant="inverse"
        header={item.header ? item.header : 0}
        text={item.text}
        value={item.header >= 100 ? 98 : item.header ? item.header : 0}
        //footer={"Click here go to pending list"}
        footer={
          <CLink
            className="font-weight-bold font-xs btn-block text-muted"
            rel="noopener norefferer"
            onClick={() => handleFooterClick(item.onClick)}
          >
            Click here go to pending list
            <CIcon name="cil-arrow-right" className="float-right" width="16" />
          </CLink>
          //   <>
          //     <div
          //       style={{
          //         borderTop: "2px solid rgba(255, 255, 255, 0.6)",
          //         marginTop: "0.5rem",
          //         marginLeft: "-1.25rem",
          //         marginRight: "-1.25rem",
          //         marginBottom: "-0.5rem",
          //       }}
          //     >
          //       &nbsp;
          //     </div>
          //     <div className="">
          //       {/* <CCardFooter className="card-footer px-3 py-2"> */}
          //       <CLink
          //         className="font-weight-bold font-xs btn-block text-muted"
          //         //href="https://coreui.io/"
          //         rel="noopener norefferer"
          //         //target="_blank"
          //         onClick={() => handleFooterClick(item.onClick)}
          //       >
          //         Click here go to pending list
          //         <CIcon
          //           name="cil-arrow-right"
          //           className="float-right"
          //           width="16"
          //         />
          //       </CLink>
          //       {/* </CCardFooter> */}
          //     </div>
          //   </>
        }
        //onClick={() => handleFooterClick(item.onClick)}
      />
    </CCol>
  );
};

export default CustomWidgetProgress;
